var styles = {"modal-content":"ConfirmChangeSliderModal_modal-content_c1p9e_1","title":"ConfirmChangeSliderModal_title_c1p9e_9","confirm":"ConfirmChangeSliderModal_confirm_c1p9e_18","timer":"ConfirmChangeSliderModal_timer_c1p9e_39"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
